import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Container,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import {
  getServiceTiersAdmin,
  createServiceTier,
  updateServiceTier,
  deleteServiceTier,
  toggleServiceTier,
} from "../../Endpoint/Admin/index";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import ConfirmModal from "../../components/Common/ConfirmModal";

// Available icons for service tiers
const TIER_ICONS = [
  { value: "ri-car-line", label: "Car" },
  { value: "ri-car-fill", label: "Car Filled" },
  { value: "ri-taxi-line", label: "Taxi" },
  { value: "ri-roadster-line", label: "Roadster" },
  { value: "ri-bus-line", label: "Bus" },
  { value: "ri-truck-line", label: "Truck" },
  { value: "ri-suv-line", label: "SUV" },
  { value: "ri-star-line", label: "Star" },
  { value: "ri-star-fill", label: "Star Filled" },
  { value: "ri-vip-crown-line", label: "Crown" },
  { value: "ri-vip-crown-fill", label: "Crown Filled" },
  { value: "ri-shield-star-line", label: "Shield Star" },
  { value: "ri-medal-line", label: "Medal" },
  { value: "ri-award-line", label: "Award" },
  { value: "ri-diamond-line", label: "Diamond" },
  { value: "ri-service-line", label: "Service" },
];

// Preset colors for service tiers
const TIER_COLORS = [
  { value: "#5664d2", label: "Primary Blue" },
  { value: "#1cbb8c", label: "Success Green" },
  { value: "#fcb92c", label: "Warning Yellow" },
  { value: "#dc3545", label: "Danger Red" },
  { value: "#ff6b6b", label: "Coral" },
  { value: "#4ecdc4", label: "Teal" },
  { value: "#9b59b6", label: "Purple" },
  { value: "#2c3e50", label: "Dark Blue" },
  { value: "#e74c3c", label: "Red" },
  { value: "#3498db", label: "Blue" },
  { value: "#f39c12", label: "Orange" },
  { value: "#1abc9c", label: "Turquoise" },
];

class ServiceTiers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tiers: [],
      isLoaded: false,
      showModal: false,
      isEditing: false,
      currentTier: {
        code: "",
        name: "",
        description: "",
        basePrice: 0,
        nightPrice: 0,
        icon: "ri-car-line",
        color: "#5664d2",
        displayOrder: 0,
        features: [],
        isActive: true,
      },
      newFeature: "",
      // Delete modal states
      showDeleteModal: false,
      selectedTierId: null,
      deleteLoading: false,
      breadcrumbItems: [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Transport", link: "/transport/requests" },
        { title: "Service Tiers", link: "#" },
      ],
      tableData: {
        columns: [
          { label: "", field: "searchField", sort: "disabled", width: 0, attributes: { style: { display: "none" } } },
          { label: "Order", field: "order", sort: "asc", width: 60 },
          { label: "Tier", field: "tier", sort: "asc", width: 200 },
          { label: "Pricing", field: "pricing", sort: "disabled", width: 150 },
          { label: "Features", field: "features", sort: "disabled", width: 150 },
          { label: "Status", field: "status", sort: "asc", width: 80 },
          { label: "Actions", field: "actions", sort: "disabled", width: 120 },
        ],
        rows: [],
      },
    };
  }

  componentDidMount() {
    this.loadTiers();
  }

  loadTiers = () => {
    getServiceTiersAdmin()
      .then((result) => {
        if (result && result.status === 200) {
          const rows = result.data.map((tier) => this.formatTierRow(tier));
          this.setState({
            tiers: result.data,
            isLoaded: true,
            tableData: { ...this.state.tableData, rows },
          });
        } else {
          toast.error(result?.message || "Failed to load service tiers");
        }
      })
      .catch(() => toast.error("Error loading service tiers"));
  };

  formatTierRow = (tier) => {
    // Create searchField for MDBDataTable search to work properly
    const searchField = [
      tier.code,
      tier.name,
      tier.description || "",
      tier.isActive ? "Active" : "Inactive",
    ].join(" ").toLowerCase();

    return {
      searchField,
      order: (
        <div className="text-center">
          <Badge color="light" className="px-3 py-2">
            {tier.displayOrder}
          </Badge>
        </div>
      ),
      tier: (
        <div className="d-flex align-items-center">
          <div
            className="d-flex align-items-center justify-content-center mr-3"
            style={{
              width: 40,
              height: 40,
              borderRadius: 8,
              backgroundColor: tier.color || "#5664d2",
              color: "#fff",
            }}
          >
            <i className={`${tier.icon || "ri-car-line"} font-size-18`}></i>
          </div>
          <div>
            <strong>{tier.name}</strong>
            <small className="d-block text-muted text-uppercase">{tier.code}</small>
            {tier.description && (
              <small className="d-block text-muted" style={{ maxWidth: 200 }}>
                {tier.description.length > 40 ? tier.description.substring(0, 40) + "..." : tier.description}
              </small>
            )}
          </div>
        </div>
      ),
      pricing: (
        <div>
          {tier.basePrice > 0 && (
            <div>
              <small className="text-muted">Base:</small> ${tier.basePrice}
            </div>
          )}
          {tier.nightPrice > 0 && (
            <div>
              <small className="text-muted">Night:</small> ${tier.nightPrice}
            </div>
          )}
          {tier.basePrice === 0 && tier.nightPrice === 0 && (
            <span className="text-muted">-</span>
          )}
        </div>
      ),
      features: (
        <div>
          {tier.features && tier.features.length > 0 ? (
            <span>
              {tier.features.length} feature{tier.features.length > 1 ? "s" : ""}
            </span>
          ) : (
            <span className="text-muted">No features</span>
          )}
        </div>
      ),
      status: (
        <Badge
          color={tier.isActive ? "success" : "secondary"}
          className="cursor-pointer"
          onClick={() => this.handleToggle(tier._id)}
          style={{ cursor: "pointer" }}
        >
          {tier.isActive ? "Active" : "Inactive"}
        </Badge>
      ),
      actions: (
        <div className="d-flex">
          <Button
            color="primary"
            size="sm"
            className="mr-1 btn-icon"
            onClick={() => this.handleEdit(tier)}
            title="Edit"
          >
            <i className="ri-edit-line"></i>
          </Button>
          <Button
            color="danger"
            size="sm"
            className="btn-icon"
            onClick={() => this.handleDelete(tier._id)}
            title="Delete"
          >
            <i className="ri-delete-bin-line"></i>
          </Button>
        </div>
      ),
    };
  };

  handleAdd = () => {
    this.setState({
      showModal: true,
      isEditing: false,
      currentTier: {
        code: "",
        name: "",
        description: "",
        basePrice: 0,
        nightPrice: 0,
        icon: "ri-car-line",
        color: "#5664d2",
        displayOrder: this.state.tiers.length,
        features: [],
        isActive: true,
      },
      newFeature: "",
    });
  };

  handleEdit = (tier) => {
    this.setState({
      showModal: true,
      isEditing: true,
      currentTier: { ...tier },
      newFeature: "",
    });
  };

  handleToggle = (id) => {
    toggleServiceTier(id)
      .then((response) => {
        if (response && response.status === 200) {
          toast.success(response.message || "Status updated");
          this.loadTiers();
        } else {
          toast.error(response?.message || "Failed to update status");
        }
      })
      .catch(() => toast.error("Error updating status"));
  };

  handleSave = () => {
    const { currentTier, isEditing } = this.state;

    if (!currentTier.code || !currentTier.name) {
      toast.error("Code and Name are required");
      return;
    }

    if (isEditing) {
      updateServiceTier(currentTier._id, currentTier)
        .then((response) => {
          if (response && response.status === 200) {
            toast.success("Service tier updated successfully");
            this.setState({ showModal: false });
            this.loadTiers();
          } else {
            toast.error(response?.message || "Failed to update service tier");
          }
        })
        .catch(() => toast.error("Error updating service tier"));
    } else {
      createServiceTier(currentTier)
        .then((response) => {
          if (response && response.status === 200) {
            toast.success("Service tier created successfully");
            this.setState({ showModal: false });
            this.loadTiers();
          } else {
            toast.error(response?.message || "Failed to create service tier");
          }
        })
        .catch(() => toast.error("Error creating service tier"));
    }
  };

  // Delete modal toggle
  toggleDeleteModal = () => this.setState({ showDeleteModal: !this.state.showDeleteModal });

  handleDelete = (id) => {
    this.setState({ selectedTierId: id, showDeleteModal: true });
  };

  confirmDelete = () => {
    const { selectedTierId } = this.state;
    this.setState({ deleteLoading: true });
    deleteServiceTier(selectedTierId)
      .then((response) => {
        if (response && response.status === 200) {
          toast.success("Service tier deleted");
          this.loadTiers();
        } else {
          toast.error(response?.message || "Failed to delete service tier");
        }
      })
      .catch(() => toast.error("Error deleting service tier"))
      .finally(() => {
        this.setState({ deleteLoading: false, showDeleteModal: false, selectedTierId: null });
      });
  };

  updateField = (field, value) => {
    this.setState({
      currentTier: { ...this.state.currentTier, [field]: value },
    });
  };

  addFeature = () => {
    const { newFeature, currentTier } = this.state;
    if (newFeature.trim()) {
      this.setState({
        currentTier: {
          ...currentTier,
          features: [...(currentTier.features || []), newFeature.trim()],
        },
        newFeature: "",
      });
    }
  };

  removeFeature = (index) => {
    const { currentTier } = this.state;
    const features = [...(currentTier.features || [])];
    features.splice(index, 1);
    this.setState({
      currentTier: { ...currentTier, features },
    });
  };

  render() {
    const { showModal, isEditing, currentTier, newFeature } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Service Tiers" breadcrumbItems={this.state.breadcrumbItems} />

            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div>
                        <h4 className="card-title mb-1">
                          <i className="ri-vip-crown-line mr-2"></i>
                          Service Tier Management
                        </h4>
                        <p className="text-muted mb-0">
                          Manage service tiers like Standard, Comfort, VIP, etc.
                        </p>
                      </div>
                      <div>
                        <Link to="/transport/vehicle-types" className="mr-2">
                          <Button color="secondary" outline>
                            <i className="ri-car-line mr-1"></i> Vehicle Types
                          </Button>
                        </Link>
                        <Button color="primary" onClick={this.handleAdd}>
                          <i className="ri-add-line mr-1"></i> Add Tier
                        </Button>
                      </div>
                    </div>

                    <MDBDataTable
                      responsive
                      bordered
                      striped
                      hover
                      noBottomColumns
                      data={this.state.tableData}
                      entriesOptions={[10, 25, 50]}
                      entries={10}
                      pagesAmount={4}
                      className="tier-table"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Add/Edit Modal */}
        <Modal isOpen={showModal} toggle={() => this.setState({ showModal: false })} size="lg">
          <ModalHeader toggle={() => this.setState({ showModal: false })}>
            {isEditing ? "Edit Service Tier" : "Add New Service Tier"}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Tier Code *</Label>
                  <Input
                    type="text"
                    value={currentTier.code}
                    onChange={(e) => this.updateField("code", e.target.value.toUpperCase())}
                    placeholder="e.g., STANDARD, COMFORT, VIP"
                    maxLength={20}
                  />
                  <small className="text-muted">Unique identifier (auto-uppercased)</small>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Tier Name *</Label>
                  <Input
                    type="text"
                    value={currentTier.name}
                    onChange={(e) => this.updateField("name", e.target.value)}
                    placeholder="e.g., Standard, Comfort, VIP"
                  />
                </FormGroup>
              </Col>
              <Col xs={12}>
                <FormGroup>
                  <Label>Description</Label>
                  <Input
                    type="textarea"
                    rows={2}
                    value={currentTier.description}
                    onChange={(e) => this.updateField("description", e.target.value)}
                    placeholder="Brief description of this service tier"
                  />
                </FormGroup>
              </Col>

              <Col xs={12}>
                <hr />
                <h6 className="mb-3">
                  <i className="ri-money-dollar-circle-line mr-1"></i>
                  Pricing
                </h6>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Base Price ($)</Label>
                  <Input
                    type="number"
                    min="0"
                    step="0.01"
                    value={currentTier.basePrice}
                    onChange={(e) => this.updateField("basePrice", parseFloat(e.target.value) || 0)}
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Night Price ($)</Label>
                  <Input
                    type="number"
                    min="0"
                    step="0.01"
                    value={currentTier.nightPrice}
                    onChange={(e) => this.updateField("nightPrice", parseFloat(e.target.value) || 0)}
                  />
                </FormGroup>
              </Col>

              <Col xs={12}>
                <hr />
                <h6 className="mb-3">
                  <i className="ri-palette-line mr-1"></i>
                  Appearance
                </h6>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Icon</Label>
                  <div className="d-flex align-items-center">
                    <Input
                      type="select"
                      value={currentTier.icon}
                      onChange={(e) => this.updateField("icon", e.target.value)}
                      style={{ flex: 1 }}
                    >
                      {TIER_ICONS.map((icon) => (
                        <option key={icon.value} value={icon.value}>
                          {icon.label}
                        </option>
                      ))}
                    </Input>
                    <div
                      className="ml-2 d-flex align-items-center justify-content-center"
                      style={{
                        width: 40,
                        height: 38,
                        borderRadius: 4,
                        backgroundColor: currentTier.color || "#5664d2",
                        color: "#fff",
                      }}
                    >
                      <i className={`${currentTier.icon} font-size-18`}></i>
                    </div>
                  </div>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Color</Label>
                  <div className="d-flex align-items-center">
                    <Input
                      type="select"
                      value={currentTier.color}
                      onChange={(e) => this.updateField("color", e.target.value)}
                      style={{ flex: 1 }}
                    >
                      {TIER_COLORS.map((color) => (
                        <option key={color.value} value={color.value}>
                          {color.label}
                        </option>
                      ))}
                    </Input>
                    <div
                      className="ml-2"
                      style={{
                        width: 40,
                        height: 38,
                        borderRadius: 4,
                        backgroundColor: currentTier.color || "#5664d2",
                      }}
                    ></div>
                  </div>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Display Order</Label>
                  <Input
                    type="number"
                    min="0"
                    value={currentTier.displayOrder}
                    onChange={(e) => this.updateField("displayOrder", parseInt(e.target.value) || 0)}
                  />
                  <small className="text-muted">Lower numbers appear first</small>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup check className="mt-4 pt-2">
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={currentTier.isActive}
                      onChange={(e) => this.updateField("isActive", e.target.checked)}
                    />
                    {" "}Tier is Active
                  </Label>
                </FormGroup>
              </Col>

              <Col xs={12}>
                <hr />
                <h6 className="mb-3">
                  <i className="ri-list-check mr-1"></i>
                  Features / Amenities
                </h6>
              </Col>
              <Col xs={12}>
                <FormGroup>
                  <InputGroup>
                    <Input
                      type="text"
                      value={newFeature}
                      onChange={(e) => this.setState({ newFeature: e.target.value })}
                      placeholder="Add a feature (e.g., Wi-Fi, Water bottle, etc.)"
                      onKeyPress={(e) => e.key === "Enter" && (e.preventDefault(), this.addFeature())}
                    />
                    <InputGroupAddon addonType="append">
                      <Button color="primary" onClick={this.addFeature}>
                        <i className="ri-add-line"></i>
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
                <div className="d-flex flex-wrap">
                  {(currentTier.features || []).map((feature, index) => (
                    <Badge
                      key={index}
                      color="light"
                      className="mr-2 mb-2 px-2 py-2"
                      style={{ fontSize: "0.85rem" }}
                    >
                      {feature}
                      <i
                        className="ri-close-line ml-2 cursor-pointer"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.removeFeature(index)}
                      ></i>
                    </Badge>
                  ))}
                  {(!currentTier.features || currentTier.features.length === 0) && (
                    <span className="text-muted">No features added yet</span>
                  )}
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.setState({ showModal: false })}>
              Cancel
            </Button>
            <Button color="primary" onClick={this.handleSave}>
              {isEditing ? "Update Tier" : "Add Tier"}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Delete Confirmation Modal */}
        <ConfirmModal
          isOpen={this.state.showDeleteModal}
          toggle={this.toggleDeleteModal}
          onConfirm={this.confirmDelete}
          title="Delete Service Tier"
          message="Are you sure you want to delete this service tier? This action cannot be undone."
          confirmText="Delete"
          confirmColor="danger"
          icon="ri-delete-bin-line"
          loading={this.state.deleteLoading}
        />

        <ToastContainer />
      </React.Fragment>
    );
  }
}

export default ServiceTiers;
